import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';
// interface LocucaoContentProps {
//   $ativo: boolean;
// }
interface ModalContainerProps {
  width: string;
}
// export const LocucaoContent = styled.div<LocucaoContentProps>`
//   opacity: ${({ $ativo }) => ($ativo ? 1 : 0.3)};
//   pointer-events: ${({ $ativo }) => ($ativo ? 'auto' : 'none')};
//   transition: opacity 0.25s ease;
// `;
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;
  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const TableCard = styled.div`
  width: 100%;
  overflow: hidden;

  background: transparent;
  border-radius: 10px;

  border: 1px solid rgba(255, 255, 255, 0.04);
`;

export const TableHeader = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #27293d;
  min-height: 64px;
  padding: 0 16px;

  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  > :nth-child(2) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    align-items: center;
    justify-content: center;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 34px;
    padding: 0 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.02em;
    transition: transform 0.15s ease, filter 0.15s ease;
    &:hover {
      transform: translateY(-1px);
      filter: brightness(1.05);
    }
    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const TableTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: #27293d;
`;

export const TableScroll = styled(PerfectScrollbar)`
  width: 100%;
  height: calc(100vh - 220px) !important;

  padding: 0 15px 4px;

  background: #27293d;

  table {
    width: 100%;
    min-width: 1100px;

    border-collapse: collapse;
    table-layout: fixed;

    thead th {
      height: 42px;

      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.04em;
      text-transform: uppercase;

      opacity: 0.68;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    tbody tr {
      transition: background-color 0.15s ease;
    }

    tbody tr:hover {
      background: rgba(255, 255, 255, 0.025);
    }

    tbody td {
      height: 54px;

      font-size: 16px;

      border-top: 1px solid rgba(255, 255, 255, 0.07);

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* NOME DO CRIATIVO */
    thead th:nth-child(1),
    tbody td:nth-child(1) {
      width: 50%;
      text-align: left;
    }

    /* STATUS */
    thead th:nth-child(2),
    tbody td:nth-child(2) {
      width: 11%;
    }

    /* CRIADO EM */
    thead th:nth-child(3) {
      text-align: center;
    }
    tbody td:nth-child(3) {
      width: 10%;
      text-align: center;
    }

    /* SOLICITANTE */
    thead th:nth-child(4),
    tbody td:nth-child(4) {
      width: 9%;
      text-align: center;
    }

    /* AÇÕES */
    thead th:nth-child(5),
    tbody td:nth-child(5) {
      width: 10%;
      text-align: right;
    }
  }
`;

export const TableNameCell = styled.td`
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.15s ease;
  &:hover {
    opacity: 0.8;
  }
`;

export const TableDateCell = styled.td`
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0.85;
`;

export const TableSolicitanteCell = styled.td`
  width: 11rem;
  text-align: center;
  > * {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TableActionsCell = styled.td`
  text-align: center;
`;

export const StepSectionsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;
  box-sizing: border-box;
  align-items: stretch;

  > * {
    width: 100%;
    height: 100% !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    box-sizing: border-box;
    align-self: stretch;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    > * {
      height: auto !important;
    }
  }
`;

export const ScrollArea = styled(PerfectScrollbar)`
  flex: 1;
  min-height: 0;
  width: 100%;
`;

/* =========================================================
   CRIATIVO STORE
   ========================================================= */

export const ScrollContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;
export const StepHeader = styled.div`
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  overflow: visible;
  h4 {
    text-align: center;
  }
  div {
    width: 100%;
    header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 14px;
      h5 {
        margin: 0 0 4px;
        color: #f8fafc;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0.08em;
      }
      p {
        margin: 0;
        color: #85859d;
        font-size: 16px;
        line-height: 1.4;
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
export const Actions = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
`;

export const ModalFooter = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding-top: 16px;
`;
export const Acoes = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;

  p {
    opacity: 0.8;
  }

  button {
    transition: transform 0.15s ease, opacity 0.15s ease;

    &:hover {
      transform: translateY(-1px);
      opacity: 0.85;
    }
  }
`;
export const ActionsLeft = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ActionsCenter = styled.div`
  position: absolute;

  left: 50%;
  transform: translateX(-50%);
`;

export const ActionsRight = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-left: auto;
`;

export const FormGroups = styled.div<{
  $columns?: string;
}>`
  display: grid;
  grid-template-columns: ${({ $columns = '1fr' }) => $columns};

  gap: 14px;
  width: 100%;

  > div {
    min-width: 0;
  }

  > div > section {
    margin-bottom: 8px;
  }

  /* > div > section h5, */
  > div > section > h5 {
    margin: 0 0 8px;
    border: solid red;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const StepSection = styled.div`
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  overflow: visible;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.055);

  > div {
    width: 100%;

    > header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 14px;

      h5 {
        margin: 0 0 4px;
        color: #f8fafc;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0.08em;
      }

      p {
        margin: 0;
        color: #85859d;
        font-size: 16px;
        line-height: 1.4;
      }
    }
  }

  /* &:last-child {
    margin-bottom: 0;
  } */
`;

export const OptionCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
export const OptionCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
`;
export const OptionCard = styled.div`
  position: relative;
  padding: 14px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  /* p {
    margin: 0 0 12px;
    color: #f8fafc;
    font-size: 13px;
    font-weight: 400;
  } */
  h5 {
    margin: 0 0 12px;
    color: #f8fafc;
    font-size: 15px;
    font-weight: 600;
  }

  > button {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
  }
`;

export const OptionalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .optional-block {
    padding: 14px;

    border-radius: 9px;

    background: rgba(255, 255, 255, 0.018);
    border: 1px solid rgba(255, 255, 255, 0.05);

    > h5 {
      margin: 0 0 12px;

      color: #f8fafc;
      font-size: 10px;
      font-weight: 600;
    }
  }

  .optional-texts {
    padding-top: 2px;
  }
`;

export const VoiceGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 0.75fr) minmax(320px, 1.25fr);

  gap: 14px;

  .voice-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .voice-texts {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;

export const TextGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  .text-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    min-width: 0;

    padding: 10px;

    border-radius: 8px;

    background: rgba(255, 255, 255, 0.018);
    border: 1px solid rgba(255, 255, 255, 0.045);
  }

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;
export const CallToActionFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ImagensContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FalasGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  margin-top: 12px;
  box-sizing: border-box;

  > div {
    flex: 1 1 0;
    width: 0;
    min-width: 0;
    box-sizing: border-box;
  }

  @media (max-width: 600px) {
    flex-wrap: wrap;

    > div {
      flex: 1 1 100%;
      width: 100%;
    }
  }
`;

export const ImagemItem = styled.div`
  min-width: 0;
  padding: 10px;

  border-radius: 9px;

  background: rgba(255, 255, 255, 0.018);
  border: 1px solid rgba(255, 255, 255, 0.055);

  > div {
    width: 100%;
  }

  section {
    display: flex;
    align-items: center;

    margin-bottom: 8px;
  }

  h5 {
    margin: 0;
    color: #f8fafc;
    font-size: 10px;

    font-weight: 600;
    letter-spacing: 0.05em;
  }
`;

export const ModalContainer = styled.div<ModalContainerProps>`
  width: ${({ width }) => width};
  max-width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  max-height: calc(100vh - 40px);

  display: flex;
  flex-direction: column;
  min-height: 0;

  box-sizing: border-box;
  background-color: ${({ theme }) => theme.cardBackgroud};
  border-radius: 0.3125em;
  padding: 1.5rem;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  padding: 20px;

  overflow-y: auto;
  background: rgba(0, 0, 0, 0.65);
`;
